var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.667 12a1.334 1.334 0 0 1 2.666 0v5.333a1.334 1.334 0 0 1-2.666 0v-5.334Zm0 9.333a1.334 1.334 0 1 1 2.667 0 1.334 1.334 0 0 1-2.667 0ZM27.82 24.47c-.306.54-.9.863-1.591.863H5.77c-.69 0-1.285-.323-1.59-.863a1.295 1.295 0 0 1 .024-1.356L14.432 6.157c.622-1.032 2.513-1.032 3.136 0l10.229 16.957c.355.587.167 1.103.023 1.356Zm2.26-2.733L19.853 4.778c-.8-1.323-2.24-2.112-3.852-2.112-1.614 0-3.054.79-3.851 2.112L1.919 21.737a3.965 3.965 0 0 0-.06 4.044c.771 1.369 2.271 2.218 3.911 2.218H26.23c1.641 0 3.14-.849 3.913-2.218a3.964 3.964 0 0 0-.061-4.044Z",
    fill: "#000"
  })));
};
export default SvgAlertTriangle;